<!-- @veltra/icons generated sha256:20067ab3526aa733 gen:8 source:src/svg/normal/caret-bottom.svg -->
<script setup lang="ts">
defineOptions({ name: 'CaretBottom' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M14.17 3.99H1.83c-.37 0-.58.39-.35.66l6.17 7.16c.18.2.52.2.7 0l6.17-7.16c.23-.27.02-.66-.35-.66"
    />
  </svg>
</template>
